import { render, staticRenderFns } from "./bangkok.vue?vue&type=template&id=4bc1cef0&scoped=true"
import script from "./bangkok.vue?vue&type=script&lang=js"
export * from "./bangkok.vue?vue&type=script&lang=js"
import style0 from "./bangkok.vue?vue&type=style&index=0&id=4bc1cef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1cef0",
  null
  
)

export default component.exports